// src/hooks/ui/useBulkStyleSendExit.js
//
// The bulk modal\'s signature shrink-fade exit, packaged for confirm-style
// modals whose SEND path should close like a batch send (SendInvoiceModal,
// 2026-08-19). Returns the morph flag + style for AnimatedModalShell and
// `playExit(action)` — arms the caller\'s exitActionRef/hasPendingExitRef and
// starts the exit, so the action fires at exit-complete (preserving the iOS
// close-before-await rule: the handler runs strictly after the modal closed).

import { useMemo, useState, useCallback } from 'react';
import useReducedMotion from '../ai/useReducedMotion';
import { prefersCoarsePointer } from '../../ui/overlayMotion';
import { modalFadeExitStyle, bulkBackgroundMorphDurationMs } from '../../ui/morphMotion';

export function useBulkStyleSendExit({ exitActionRef, hasPendingExitRef, setAnimOpen }) {
  const reduced = useReducedMotion();
  const isTouch = useMemo(() => prefersCoarsePointer(), []);
  const [sendMorph, setSendMorph] = useState(false);
  const sendMorphExitStyle = useMemo(
    () => modalFadeExitStyle({ reduced, durationMs: bulkBackgroundMorphDurationMs(isTouch) }),
    [reduced, isTouch],
  );
  const playExit = useCallback((action) => {
    // The refs are optional: a host that closes through onExitComplete alone passes none.
    if (exitActionRef) exitActionRef.current = action;
    if (hasPendingExitRef) hasPendingExitRef.current = true;
    setSendMorph(true);
    setAnimOpen(false);
  }, [exitActionRef, hasPendingExitRef, setAnimOpen]);
  return { sendMorph, sendMorphExitStyle, playExit, reduced };
}
